/**
 * Validates an email address.
 * @param email - The email address to validate.
 * @returns An error message if the validation fails, otherwise an empty string.
 */
export const validateEmail = (email: string): string => {
  if (email.trim() === "") {
    return "Please enter your email address.";
  }

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
    return "Please enter a valid email address.";
  }

  return ""; // No errors
};

/**
 * Validates a username (email format).
 * @param username - The username to validate.
 * @returns An error message if the validation fails, otherwise an empty string.
 */
export const validateUsername = (username: string): string => {
  if (username.trim() === "") {
    return "Please enter your username.";
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(username)) {
    return "Please enter a valid email address.";
  }
  return ""; // No errors
};

/**
 * Returns individual password rule validation statuses.
 * @param password - The password to validate.
 * @returns Array of rules with label and isValid status.
 */
export const validatePassword = (password: string) => {
  return [
    {
      label: "At least 8 characters",
      isValid: password.length >= 8,
    },
    {
      label: "At least one uppercase letter",
      isValid: /[A-Z]/.test(password),
    },
    {
      label: "At least one lowercase letter",
      isValid: /[a-z]/.test(password),
    },
    {
      label: "At least one number",
      isValid: /[0-9]/.test(password),
    },
    {
      label: "At least one special character",
      isValid: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    },
  ];
};

/**
 * Checks if passwords match.
 * @param password - The password.
 * @param confirmPassword - The confirmation password.
 * @returns An error message if they don't match, otherwise an empty string.
 */
export const validatePasswordMatch = (
  password: string,
  confirmPassword: string
): string => {
  if (password !== confirmPassword) {
    return "Confirm password should be same as New password";
  }
  return ""; // No errors
};

export const validateName = (name: string): string => {
  if (name.trim() === "") {
    return "Please enter your name.";
  }
  return "";
};

export const validateFirstName = (name: string): string => {
  if (name.trim() === "") {
    return "Please enter your first name.";
  }
  if (!/^[a-zA-Z\s.'-]+$/.test(name.trim())) {
    return "First name can only contain letters, spaces, period (.), apostrophe ('), and hyphen (-)";
  }
  if (name.trim().length < 2) {
    return "First name must be at least 2 characters.";
  }
  if (name.trim().length > 50) {
    return "First name cannot exceed 50 characters.";
  }
  return "";
};

export const validateLastName = (name: string): string => {
  if (name.trim() === "") {
    return "Please enter your last name.";
  }
  if (name.trim().length > 50) {
    return "Last name cannot exceed 50 characters.";
  }
  if (!/^[a-zA-Z\s.'-]+$/.test(name.trim())) {
    return "Last name can only contain letters, spaces, period (.), apostrophe ('), and hyphen (-)";
  }
  return "";
};

export const validatePhone = (phone: string): string => {
  if (phone.trim() === "") {
    return "Please enter your phone number.";
  }
  if (!/^\d{10}$/.test(phone)) {
    return "Please enter a valid 10-digit phone number.";
  }
  return "";
};
